/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */

import { selectTranslations } from 'app/pages/App/slice/selectors';
import React, { memo } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { purifyHtml } from 'utils/helper';
// import { removeScripts } from '@utils/helper';

interface Props {
  isShow: boolean;
  content?: any | string;
  title?: string;
  onCloseDialog: () => void;
}

const DialogCondition = memo(
  ({ isShow, content, title, onCloseDialog }: Props) => {
    const translations = useSelector(selectTranslations);

    return (
      <Modal
        show={isShow}
        centered
        onHide={onCloseDialog}
        className="modal modal_Condition fade"
        id="ModalCondition"
      >
        <Modal.Body>
          <div className="--top">
            <h4>
              <i className="fa-solid fa-file" />{' '}
              {translations ? translations['b2c.txt.modal-ticket-title'] : ''}
            </h4>
            <button type="button" className="close" onClick={onCloseDialog}>
              <i className="fa-solid fa-xmark" />
            </button>
          </div>
          <div className="--bot">
            <div className="--name mb-3">
              <span>
                {translations ? translations['b2c.txt.modal-ticket-name'] : ''}:
              </span>
              {title}
            </div>
            <div className="--des">
              <span>
                {translations
                  ? translations['b2c.txt.modal-ticket-content']
                  : ''}
                :
              </span>
              <article
                dangerouslySetInnerHTML={{
                  __html: purifyHtml(content || ''),
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  },
);

export default DialogCondition;
